let now = new Date()
let dd = now.getDate()
let mm = now.getMonth() + 1
const yyyy = now.getFullYear() - 18

export const today = `${mm}/${dd}/${yyyy}`